import { battleCardsDefRepository } from "~/business";
import { XBadgeCounter, XTypography } from "~/jsx/components/design";
import { Colors, FontSize, Spacing } from "~/jsx/theme";
import { XBattleCardWithPodium } from "./XBattleCardWithPodium";
import { useGame } from "~/app";

export const XBattleInfos = () => {
  const { game } = useGame();
  const { battleDeck } = game;
  const nextCard = battleDeck.last();

  const nextLevel = nextCard?.getDef(battleCardsDefRepository).level ?? 3;
  return (
    <div
      style={{
        display: "flex",
        gap: Spacing.px4,
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ position: "relative" }}>
        <XBattleCardWithPodium />
        <XBadgeCounter value={battleDeck.length + 1} size={24} />
      </div>
      <XTypography
        typographyStyle={{
          color: Colors.grey.c3,
          fontSize: FontSize.px12,
        }}
      >
        Next card level: {nextLevel}
      </XTypography>
    </div>
  );
};
